import React from 'react';
import { UserAlert } from '../../atoms/alerts';
import { MetricCard } from '../../atoms';
import { PreferredPartner } from '../../molecules';
import { CommentSection, RatingCard, DoughnutGraph, Bargraph } from '../../organisms';
import { commaingNumber } from '../../../../utils';
import { gymbooking, india_map, WalletIcon } from '../../../../assets/images';
import WalletUtilizationCommon from './WalletUtilizationCommon';
import Skeleton from 'react-loading-skeleton';

const GymAndFitness = ({ metricObj, commentsObj, utilizationObj, ratingObj, loading, walletUtilizationObj, benefitName }) => {
  const { total_sposored_session, total_session_utilized, coverage, donutGraphData, activeCustomerCount, unique_users, repeat_users } = metricObj;
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { partners, activities } = commentsObj;
  const { barlabels, bardata, barBgColors } = utilizationObj;
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;

  return (
    <div>
      <p className='mt-8 mb-3 font-semibold text-gray-700 text-base leading-none'>Gym bookings</p>
      <div className='flex flex-row justify-between'>
        { walletEnable && (totalWalletAmount > 0) && (<MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={WalletIcon}
            titleClasses='font-semibold text-gray-800'
            title='Total amount added'
            subTitle='Total amount added for employee and dependent wallet utilization'
            metricClasses='flex mt-0 text-gray-500'
            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalWalletAmount)}</span>}
            classes='w-1/2 inline-block mr-5'
        />)}

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={gymbooking}
          title='Total sponsored session'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_sposored_session)}</span>
          }
          metricValueSuffix=''
          classes='w-1/2 mr-4'
        />

        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={gymbooking}
          title='Total sessions utilized'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_session_utilized)}</span>
          }
          metricValueSuffix=''
          classes='w-1/2'
        />
      </div>

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={activeCustomerCount}/>

      <div className='flex flex-row justify-between mt-12'>
        <div className='flex flex-col w-1/2 mr-4'>
          <p className='text-gray-700 text-base mb-3 font-semibold leading-none'>
            Top preferred partners by your employees
          </p>
          <PreferredPartner loading={loading} loaderHeight={200} list={partners} header='Partners' classes='h-full' />
        </div>
        <div className='flex flex-col w-1/2'>
          <p className='text-gray-700 text-base font-semibold leading-none mb-3'>
            Top preferred activity by your employees
          </p>
          <PreferredPartner loading={loading} loaderHeight={200} list={activities} header='Activity' classes='h-full' />
        </div>
      </div>

      <div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold leading-none text-gray-700 mb-1'>Ratings and Reviews</div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These ratings are captured after completing the gym & fitness.
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='flex flex-col w-2/4'>
          <div className='text-base font-semibold leading-none text-gray-700 mb-1'>Top Comments</div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These reviews are captured after completing the gym & fitness.
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>

      <div className='text-base font-semibold leading-none text-gray-700 mb-3 mt-12'>Session wise booking</div>
      <div className='flex flex-row'>
        <div className='flex flex-col w-2/4 pr-4'>
          <DoughnutGraph
            loading={loading}
            loaderHeight={200}
            title={'Sessions'}
            graphData={donutGraphData}
            tooltip_placement='top'
            classes='h-full'
            id={'gym'}
          />
        </div>

        <div className='flex flex-col w-2/4'>
          {loading ? (
            <Skeleton width='100%' height={200} />
          ) : (
            <div className='bg-white h-full border p-6 rounded'>
              <img src={india_map} alt='india_map' className='mb-4' />
              <p className='mb-1 text-gray-500 text-sm'>
                Your employees can persue fitness with the best fitness expert,
              </p>
              <p className='mb-0 text-gray-500 text-sm'>
                ekincare coverage is across{' '}
                <span className='font-semibold text-gray-600'>{6000}+ fitness studios PAN India</span>
              </p>
            </div>
          )}
        </div>
      </div>

      <div className='text-base font-semibold leading-none text-gray-700 mb-3 mt-12'>Utilization based on location</div>
      <div
        className={'mt-3 rounded-md ' + (loading ? '' : 'bg-white ') + (bardata && bardata.length === 0 ? 'pt-6 ' : '')}
      >
        {bardata && bardata.length === 0 && <UserAlert para='Locations data is not available' paraClasses=' font-semibold text-gray-600' imgClasses=' h-5 w-5' classes=' p-4 ml-6 mr-4'/>}
        <Bargraph
          loading={loading}
          loaderHeight={300}
          id='utilizationbargraph'
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='350px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel='Locations'
          yAxesLabel='Utilization percentages'
        />
      </div>
    </div>
  );
};

export default GymAndFitness;
